import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from 'src/app/types';

@Component({
  selector: 'app-review-form-suspected-items',
  templateUrl: './review-form-suspected-items.component.html',
  styleUrl: './review-form-suspected-items.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormSuspectedItemsComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
  public selectedItems = input<Set<number>>(new Set());
  public toggleItem = output<number>();
}
